import { C8DateRangeArray } from "csi/typings";
import { isNullOrUndefined } from "csi/utility/coreUtility";

type DateOrTime = Date | number;

export class C8DateRange {
	private from: number;
	private to: number;
	selection?: number;
	numberOfDays?: number;

	constructor(from?: DateOrTime, to?: DateOrTime, selection?: number, numberOfDays?: number) {
		this.from = this.convertToEpochMillis(from);
		this.to = this.convertToEpochMillis(to);
		this.selection = selection;
		this.numberOfDays = numberOfDays;
	}

	private convertToEpochMillis(dateOrTime?: DateOrTime): number {
		if (!dateOrTime) {
			return 0;
		}

		return dateOrTime instanceof Date ? dateOrTime.getTime() : dateOrTime;
	}

	/** convert date range to array of numbers */
	get toArray(): C8DateRangeArray {
		const arr: C8DateRangeArray = [0, 0];
		const { from, to, selection, numberOfDays } = this;
		arr[0] ||= from;
		arr[1] ||= to;

		if (selection) {
			arr.push(selection);
		}

		if (!isNullOrUndefined(numberOfDays)) {
			arr.push(numberOfDays);
		}

		return arr;
	}

	get fromDate(): Date {
		const { from } = this;
		return from ? new Date(from) : undefined;
	}

	get toDate(): Date {
		const { to } = this;
		return to ? new Date(to) : undefined;
	}

	setFromDate = (date?: Date): void => {
		this.from = date?.getTime();
	};

	setToDate = (date?: Date): void => {
		this.to = date?.getTime();
	};

	get fromEpochMillis(): number {
		return this.from;
	}

	get toEpochMillis(): number {
		return this.to;
	}
}